export const responsiveEndPoints = {
  mobile: '780',
  responsive: '1360'
};
